module.exports = __webpack_public_path__ + "media/payment/american-express-f1e74639.svg";